/**
 * ─── SMS Gateways Source of Truth ──────────────────────────────────────────
 * 
 * Centralized mapping of carriers to their primary SMS email gateways.
 * 
 * NOTE: Most carriers only accept messages addressed to their specific domain.
 * Blasting multiple domains often results in "Address not found" NDRs.
 */

export const CARRIER_GATEWAYS: Record<string, string[]> = {
  'T-Mobile':           ['tmomail.net'],
  'Verizon':            ['vtext.com', 'vzwpix.com'],
  'AT&T':               ['mms.att.net'],
  'Sprint':             ['messaging.sprintpcs.com'],
  'Boost Mobile':       ['sms.myboostmobile.com'],
  'Metro by T-Mobile':  ['tmomail.net'],
  'Cricket':            ['sms.cricketwireless.net'],
  'Visible':            ['vtext.com'],
  'Google Fi':          ['msg.fi.google.com'],
  'Unknown':            ['tmomail.net', 'vtext.com', 'mms.att.net'],
};

/**
 * Universal fallback gateway.
 */
export const UNIVERSAL_SMS_GATEWAYS = ['tmomail.net', 'vtext.com', 'mms.att.net'];

/**
 * All known domains for inbound filtering.
 */
export const ALL_GATEWAY_DOMAINS = [
  'vtext.com', 'vzwpix.com',
  'tmomail.net',
  'msg.fi.google.com',
  'mms.att.net',
  'messaging.sprintpcs.com',
  'sms.myboostmobile.com',
  'sms.cricketwireless.net',
  'ptel.com',
  'text.republicwireless.com',
];
